var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CRow',[_c('CCol',[_c('CInput',{attrs:{"type":"text","name":"text","label":"Raison de litige","value":_vm.complaint ? _vm.complaint.text : null}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }